export default "__VITE_ASSET__Cpp43g6Z__"